import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { useBottomDialogDispatch } from './BottomDialogContext';
import SvgClose from '../../../../play-core/icons/Close';
import { Colors } from '../../../../play-core/styles/Colors';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { zIndex } from '../../../../play-core/styles/z-index';
import { useLockBodyScroll } from '../../hooks/use-lock-body-scroll';
import { TransparentButton } from '../ClickableComponents/Button';
import { headerShadow } from '../Header/Header.globals';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const BottomDialogHeader = () => {
  const {
    t
  } = useTranslation();
  const dispatch = useBottomDialogDispatch();
  useLockBodyScroll();
  return /*#__PURE__*/_jsx(StickyContainer, {
    children: /*#__PURE__*/_jsx(CloseButton, {
      icon: /*#__PURE__*/_jsx(IconWrapper, {
        color: Colors.WHITE,
        icon: /*#__PURE__*/_jsx(SvgClose, {})
      }),
      ariaLabel: t('global.close'),
      type: "icon",
      onClick: () => dispatch({
        type: 'remove-dialog'
      })
    })
  });
};
export const headerHeight = 64;
const StickyContainer = styled.div.withConfig({
  displayName: "BottomDialogHeader__StickyContainer",
  componentId: "sc-1pfitp9-0"
})(["position:fixed;right:0;left:0;z-index:", ";display:flex;align-items:center;justify-content:space-between;width:100%;height:", "px;", "{background-color:", ";", ";}"], zIndex.header, headerHeight, Viewports.for('small'), Colors.GREY_1a1a1a, headerShadow);
const CloseButton = styled(TransparentButton).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "BottomDialogHeader__CloseButton",
  componentId: "sc-1pfitp9-1"
})(["margin-left:8px;", "{position:absolute;top:24px;right:24px;}"], Viewports.for('mediumUp'));